// Feefo doesn't sync ratings to metafields, so each product card fetches its
// own summary. Feefo can batch by variant SKU, but aggregated variant ratings
// don't always match the product summary shown on the PDP. Responses are
// CDN/browser cached for 24h.
const feefoRatingRequests = new Map();
const pluralRules = new Intl.PluralRules(document.documentElement.lang || undefined);

function fetchFeefoRating(productId) {
  if (!feefoRatingRequests.has(productId)) {
    const url = `https://api.feefo.com/api/10/reviews/summary/product?merchant_identifier=yawn&since_period=ALL&parent_product_sku=${productId}`;
    feefoRatingRequests.set(
      productId,
      fetch(url)
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null)
    );
  }
  return feefoRatingRequests.get(productId);
}

class FeefoProductRating extends HTMLElement {
  connectedCallback() {
    if (this.rendered) return;
    this.rendered = true;

    fetchFeefoRating(this.dataset.productId).then((data) => {
      const count = data?.meta?.count;
      const rating = data?.rating?.rating;
      if (!count || !rating) return;

      // Markup decides what's shown: product cards have a rating only, the
      // PDP adds stars (filled to --rating) and a review count.
      const label = pluralRules.select(count) === 'one' ? this.dataset.labelOne : this.dataset.labelOther;
      const countRef = this.querySelector('[data-ref-count]');

      this.querySelector('[data-ref-rating]').textContent = rating.toFixed(1);
      if (countRef) countRef.textContent = count;
      this.querySelector('[data-ref-label]').textContent = label.replace('[rating]', rating.toFixed(1)).replace('[count]', count);
      // Stars fill to the exact rating, as Feefo's do (4.9 → last star 90% full).
      this.style.setProperty('--rating', rating);
      this.classList.add('is-loaded');
    });
  }
}

customElements.define('component-feefo-product-rating', FeefoProductRating);
